import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { BasePrompt, ControlTypes } from '../../../../forms/models'

@Component({
  selector: 'mp-dynamic-prompt',
  templateUrl: './dynamic-prompt.html'
})
export class DynamicFormQuestionComponent implements OnInit {
  @Input() public prompt: BasePrompt<any>
  @Input() public form: FormGroup
  @Input() public infoTooltip: string

  @Output() public dataChanged: EventEmitter<any> = new EventEmitter<any>()

  public get control() { return this.form.controls[this.prompt.key] }
  public get isValid() { return this.control.valid }
  public controlTypes = ControlTypes

  public onChange(data) {
    this.dataChanged.emit(data)
  }

  public ngOnInit() {
    this.control.valueChanges.subscribe((value) => {
      this.prompt.value = value
    })

    this.prompt.onValueChanged.subscribe((value) => {
      this.control.patchValue(value, { emitEvent: false })
    })
  }

  public isFormArrayControlDisabled(index: number): boolean {
    return this.form.get(this.prompt.key).get(index.toString()).disabled
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/dynamic-form/dynamic-prompt/dynamic-prompt.component.ts